import React from 'react';
import styled from "styled-components";
import Logo from "./Logo";

const Welcome = () => {
    return (
        <Container>
            <div style={{paddingTop: 20}}>
                <div className='header'>
                    <Logo full={true}/>
                    <h3 style={{paddingBottom: "0.5rem", paddingTop: "2rem"}}>Welcome to <span style={{color: "#7269ef"}}>FM Messenger!</span></h3>
                    <h4>You can search users by their Email address and add them to your contacts.</h4>
                    <h4 style={{paddingBottom: "2rem"}}>So add your friends and start chatting...</h4>

                    <h4>This is a MERN stack sample project</h4>
                    <p style={{paddingTop: "0.5rem"}}>Notable used dependencies:</p>
                    <ul style={{paddingLeft: "2rem"}}>
                        <li>express (hono on Cloudflare Workers in this host)</li>
                        <li>react</li>
                        <li>mongoose (PostgreSQL in this host)</li>
                        <li>jsonwebtoken</li>
                        <li>socket.io (WebSockets with Durable Objects in this host)</li>
                        <li>axios</li>
                        <li>bcryptjs</li>
                        <li>redux</li>
                        <li>styled-components</li>
                    </ul>
                    <p  style={{paddingTop: "2rem"}}>© 2022  FM Messenger. Developed by
                        <a href='https://fmcv.ir' target="_blank" rel="noreferrer"> Fmcv.ir</a>
                    </p>
                </div>
            </div>
        </Container>
    );
}

export default Welcome;

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0px 8px;
  border-left: #ECEDF6 solid 2px;
  border-right: #ECEDF6 solid 2px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0.2rem;

    &-thumb {
      background-color: #D1D6DB;
      width: 0.1rem;
      border-radius: 1rem;
    }
  }
  
  .form-input-container {
    position: relative;
    display: flex;
  }

  .header {
    padding: 12px 16px 24px 16px;
  }
`;